import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { AlertController, LoadingController, ToastController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { ChatService } from 'src/app/services/chat.service';
import { ValidarToken } from 'src/app/validators/valida-datos';

@Component({
  selector: 'app-add-plantillas',
  templateUrl: './add-plantillas.component.html',
  styleUrls: ['./add-plantillas.component.scss'],
})
export class AddPlantillasComponent implements OnInit {

  pasos: number;
  plantillaForm: FormGroup;
  archivo: any;
  nombreFile: string;
  classUser: any;
  previsualizacion: any;

  constructor(
    private loadingController: LoadingController,
    private toastController: ToastController,
    private chatService: ChatService,
    private storage: Storage,
    private alertController: AlertController,
    private sanitizer: DomSanitizer
  ) {
    this.pasos = 1;
    this.previsualizacion = null;
  }

  ngOnInit() {
    this.classUser = new ValidarToken(this.storage);
    this.formBuild();
  }

  formBuild() {
    this.plantillaForm = new FormGroup({
      nombre: new FormControl('', [Validators.required, Validators.minLength(2)]),
      descripcion: new FormControl('', [Validators.minLength(2), Validators.required])
    });
  }

  siguiente(val) {
    this.pasos = val;
  }

  file(ev) {
    this.presentLoading('Agregando Imagen...');
    const archivoCap = ev.target.files[0];
    const nombreCortado = archivoCap.name.split('.');
    const extension = nombreCortado[ nombreCortado.length -1 ];
    const extensionesValidas = ['png', 'jpg', 'jpeg', 'JPEG', 'PNG', 'JPG'];
      if(!extensionesValidas.includes(extension)){
        this.loadingController.dismiss();
        this.presentToast('Error, Extensión inválida', 'danger');
        return;
      }
      if(archivoCap.size <= 2000000) {
        this.archivo = archivoCap;
        this.extraerBase64(archivoCap).then((imagen: any) => {
             this.previsualizacion = imagen.base;
        });
        this.uploadArchivo();
      } else  {
        this.loadingController.dismiss();
        this.presentToast('El tamaño de la imagen debe se ser menor a 2 MG', 'warning');
      }
  }

  uploadArchivo() {

  const formFile = new FormData();
  formFile.append('file0', this.archivo);
  this.chatService.uploadArchivo(formFile, this.classUser.idMongo).subscribe(
    (res: any) => {
      if ( res.status === 'success') {
        this.loadingController.dismiss();
        this.presentToast('Imagen cargada!', 'success');
        this.nombreFile = res.result.Location;
      }
    },
    error => {
      console.log(error);
      this.loadingController.dismiss();
      this.presentToast('Hubo un error al cargar la imagen. Intenta más tarde', 'danger');
    });
}

extraerBase64 = async ($event: any) => new Promise((resolve, reject) => {
  try {
    const unsafeImg = window.URL.createObjectURL($event);
    const image = this.sanitizer.bypassSecurityTrustUrl(unsafeImg);
    const reader = new FileReader();
    reader.readAsDataURL($event);
    reader.onload = () => {
      resolve({
        base: reader.result
      });
    };
    reader.onerror = error => {
      resolve({
        base: null
      });
    };

  } catch (e) {
    return null;
  }
});

  addPlantilla() {
    const data = {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      id_admin: this.classUser.idAdmin,
      nombre: this.plantillaForm.value.nombre,
      descripcion: this.plantillaForm.value.descripcion,
      imgSolicitud: this.nombreFile,
    };

    console.log(data);

    this.chatService.addPlantilla(data, this.classUser.id, this.classUser.rol, this.classUser.token, '').subscribe(
      (res: any) => {
        if(res.status === 'success') {
          this.presentAlert('Exito!', 'Plantilla creada correctamente', 'Espera a que sea validada');
          this.previsualizacion = null;
          this.plantillaForm.reset();
          this.pasos = 1;
        } else {
          this.presentAlert('Error!', 'No se pudo cargar la plantilla', 'intenta más tarde ó contacta a soporte');
        }
      },
      err => {
        console.log(err);
        this.presentAlert('Error!', 'No se pudo cargar la plantilla', 'intenta más tarde ó contacta a soporte');
      }
    );
  }

  async presentLoading(message) {
    const loading = await this.loadingController.create({
      cssClass: 'my-custom-class',
      message,
      // duration: 2000
    });
    await loading.present();
  }

  async presentToast(message, color) {
    const toast = await this.toastController.create({
      message,
      duration: 1500,
      position: 'bottom',
      color
    });

    await toast.present();
  }

  async presentAlert(header, subHeader, message) {
    const alert = await this.alertController.create({
      header,
      subHeader,
      message,
      buttons: ['Aceptar'],
    });

    await alert.present();
  }

}
